import { Button, ButtonProps } from '@cast/design-system';

import { Link } from 'components/router';

import { makeSelectionTemplatesLink } from '../../utils';

type GoToNodeTemplatesButtonProps = Omit<ButtonProps<typeof Link>, 'to'> & {
  clusterId: string;
};

export const GoToNodeTemplatesButton = ({
  clusterId,
  ...buttonProps
}: GoToNodeTemplatesButtonProps) => {
  return (
    <Button
      {...buttonProps}
      testId="go-to-node-templates-button"
      component={Link}
      to={makeSelectionTemplatesLink({
        clusterId,
      })}
      rel="noopener noreferrer"
      target="_blank"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      Go to Node templates
    </Button>
  );
};
